import { ThemeProvider as MuiThemeProvider, useTheme as useMuiTheme } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import React from 'react';
import theme from './mui-config';
export const useTheme = () => useMuiTheme();
export const ThemeProvider = ({ children, ...rest }) => (React.createElement(MuiThemeProvider, Object.assign({ theme: theme }, rest),
    React.createElement(CssBaseline, null),
    children));
//# sourceMappingURL=muiTheme.js.map